import React from 'react'
import PropTypes from 'prop-types'
import styles from './Card.scss'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { classNames, variationName } from './../../../utils/styles'

const Card = ({ title, icon, children, onRemove = null, canRemove }) => {
  const type =
    (children.type && children.type.name === undefined && children.type === 'input' && children.props.type) || 'normal'
  const classes = classNames(styles.Card, styles[variationName('type', type)])

  const ElementTag = type === 'checkbox' ? 'label' : 'div'
  return (
    <ElementTag className={classes}>
      {canRemove &&
        onRemove && (
          <Button onClick={onRemove} plain className={styles.Remove}>
            <Icon size="small" source="bin" />
          </Button>
        )}
      <div className={styles.Title}>{title}</div>
      {React.cloneElement(icon, { size: 'ExtraLarge', className: styles.Icon })}
      {React.Children.only(children)}
    </ElementTag>
  )
}

export default Card

Card.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.element,
  children: PropTypes.any,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  canRemove: PropTypes.bool,
}

export { default as Cards } from './Cards'
export { default as CardButton } from './CardButton'



// WEBPACK FOOTER //
// ./src/components/Form/Card/index.js